import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    image: {
        objectFit: "contain",
        alignSelf: "center",
        height: 200,
        width: 350
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    contentContainer: {
        alignItems: "flex-start"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitle: {
        textAlign: "center"
    },
    container: {
        paddingTop: 0
    },
    flex1: {
        flex: 1
    }
});
export default stylesheet;
